// =========================================
// Integration Types
// =========================================
export var IntegrationType;
(function (IntegrationType) {
    IntegrationType["SLACK"] = "slack";
    IntegrationType["SENDGRID"] = "sendgrid";
    IntegrationType["SALESFORCE"] = "salesforce";
    IntegrationType["HUBSPOT"] = "hubspot";
    IntegrationType["ZOHO"] = "zoho";
    IntegrationType["DYNAMICS"] = "dynamics";
    IntegrationType["TEAMS"] = "teams";
    IntegrationType["WEBHOOK"] = "webhook";
    // Product-management connectors (2026-10-16). Unlike the CRMs (write-only
    // outbound), these are BIDIRECTIONAL: they pull backlog + roadmap INTO the
    // product's agent context, and push captured feature-requests/action-items
    // OUT as backlog issues. v1 auth is API-token (Basic for Jira, key for
    // Linear) — the HubSpot PAT path, not the Salesforce OAuth dance.
    IntegrationType["JIRA"] = "jira";
    IntegrationType["LINEAR"] = "linear";
    // Document connector (2026-10-18): pulls Confluence pages INTO a product's
    // Library as documents. Atlassian auth, same as Jira (siteUrl + email + API
    // token, Basic). Read-only (import), not bidirectional like the PM connectors.
    IntegrationType["CONFLUENCE"] = "confluence";
})(IntegrationType || (IntegrationType = {}));
export var IntegrationStatus;
(function (IntegrationStatus) {
    IntegrationStatus["ACTIVE"] = "active";
    IntegrationStatus["INACTIVE"] = "inactive";
    IntegrationStatus["ERROR"] = "error";
    IntegrationStatus["PENDING"] = "pending";
})(IntegrationStatus || (IntegrationStatus = {}));
export var SlackNotifyEvent;
(function (SlackNotifyEvent) {
    SlackNotifyEvent["DEMO_STARTED"] = "demo_started";
    SlackNotifyEvent["DEMO_COMPLETED"] = "demo_completed";
    SlackNotifyEvent["HIGH_INTENT_LEAD"] = "high_intent_lead";
    SlackNotifyEvent["HANDOFF_REQUESTED"] = "handoff_requested";
    SlackNotifyEvent["CTA_CLICKED"] = "cta_clicked";
    SlackNotifyEvent["MEETING_BOOKED"] = "meeting_booked";
    SlackNotifyEvent["BRIEF_GENERATED"] = "brief_generated";
})(SlackNotifyEvent || (SlackNotifyEvent = {}));
export var WebhookEventType;
(function (WebhookEventType) {
    WebhookEventType["DEMO_STARTED"] = "demo.started";
    WebhookEventType["DEMO_COMPLETED"] = "demo.completed";
    WebhookEventType["PROSPECT_ENRICHED"] = "prospect.enriched";
    WebhookEventType["LEAD_SCORED"] = "lead.scored";
    WebhookEventType["BRIEF_GENERATED"] = "brief.generated";
    WebhookEventType["CTA_CLICKED"] = "cta.clicked";
    WebhookEventType["HANDOFF_REQUESTED"] = "handoff.requested";
    WebhookEventType["MEETING_BOOKED"] = "meeting.booked";
    WebhookEventType["CONTACT_CREATED"] = "contact.created";
    WebhookEventType["DEAL_UPDATED"] = "deal.updated";
})(WebhookEventType || (WebhookEventType = {}));
//# sourceMappingURL=integrations.js.map